/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 8/27/13
 * Time: 5:34 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var $ = require("jquery");
    var _ = require("underscore");
    var Marionette = require("marionette");
    var tabItemTemplate = require("ui/tabsbar/templates/tabItem.tmpl");
    var Button = require("ui/button/Button");
    var Checkbox = require("ui/checkbox/Checkbox");

    var NOT_CLICKABLE_CLASS = "not-clickable";
    var ELLIPSIS = "ellipsis";

    var TabItemView;

    /*
     this view represents the different engagement states (currently online, offline, etc.)
     */
    TabItemView = Marionette.ItemView.extend({
        template: tabItemTemplate,
        tagName: "li",
        className: "tab",

        modelEvents: {
            "change:tabClickable": "_updateTabClickableClass",
            "change:hasContent" : "_handleHasContentAttributeChanged"
        },
        ui: {
            checkboxWrapper: ".checkbox-wrapper",
            buttonWrapper: ".button-wrapper",
            tab:             ".tab-content"
        },
        events: {
            "click .tab-content": "_tabClicked"
        },

        initialize: function (options) {
            options = options || {};
            this.vent = options.vent;
            this.continueOnTabChange=options.continueOnTabChange;
        },
        uiComponents: {
        },

        onRender: function () {
            if (this.model.get("hasCheckbox")) {
                this._renderCheckbox();
            }
            this._updateTabClickableClass();
            this._ellipsis();
            this._handleHasContentAttributeChanged();
            //add button-tab class
            if (this.model.get("isButton") === true) {
                this.addClass("button-tab");
                this._renderButton();
            } else {
                this.removeClass("button-tab");
            }
            if(this.model.get("isAll") === true) {
                this.addClass("tab-all");
            }
            this._handleDataAttributes();
        },
        removeClass : function(cssClass){
            this.$el.removeClass(cssClass);
        },
        addClass : function(cssClass){
            this.$el.addClass(cssClass);
        },
        _renderCheckbox: function () {
            var that = this;
            this.uiComponents.host$.createAndRender("checkbox", {
                type: Checkbox,
                options: {
                    el: "view.ui.checkboxWrapper",
                    permutation: Checkbox.PERMUTATION.B,
                    checked: that.model.get("checkBoxValue"),
                    enabled: that.model.get("checkboxEnabled"),
                    stopPropagationOnClick: true
                },
                events: {
                    "change": '_checkboxClicked'
                }
            });

            return this;
        },
        _renderButton: function () {
            var that = this;
            this.uiComponents.host$.createAndRender("button", {
                type: Button,
                options: {
                    el: "view.ui.buttonWrapper",
                    permutation: that.model.get("btnPermutation"),
                    initState: that.model.get("btnState")
                },
                events: {
                    "click": '_buttonClicked'
                }
            });

            return this;
        },
        _checkboxClicked: function (componentId, eventName, isChecked) {
            this.model.set("checkBoxValue", isChecked);
            this.trigger("checkbox:clicked", this.model);
        },
        _tabClicked: function (ev) {
            if (!this.model.get("isButton") && this.isClickTested() && this.model.get("tabClickable")) {  //we dont test moving to a tab if its a button
                this.trigger("tab:changed", this.model);
            }
        },
        _buttonClicked: function(){
            this.trigger("button:clicked", this.model);
        },
        _handleHasContentAttributeChanged: function(){
            var contentFullClass = "tab-content-full";
            this.removeClass(contentFullClass) ;

            if (this.model.get("hasContent")){
                this.addClass(contentFullClass);
            }
        },
        _updateTabClickableClass: function() {
            this.$el.addClass(NOT_CLICKABLE_CLASS, !this.model.get("tabClickable"));
        },
        _ellipsis: function() {
            if(this.model.get("isEllipsis") && !this.model.get("isButton")) {
                this.ui.tab.addClass(ELLIPSIS);
                if(_.isEmpty(this.model.get("tooltip"))) {
                    this.model.set("tooltip", this.model.get("name"));
                }
            }
        },
        _handleDataAttributes: function() {
            if (!_.isEmpty(this.model.getDataAttributes())) {
                var dataAttributes = this.model.getDataAttributes();
                _.each(dataAttributes, function(attributeValue, attributeKey) {
                    this.$el.attr("data-" + attributeKey, attributeValue);
                },this);
            }
        },
        isClickTested:function(){
            var testedOk=true;
            if(this.continueOnTabChange && _.isFunction(this.continueOnTabChange)){
                testedOk = this.continueOnTabChange();
            }
            return testedOk;
        },
        //continueOnTabChange
        onClose: function () {

        },
        setError:function(isError){
            if(isError){
                this.$el.addClass("error");
            }
            else{
                this.$el.removeClass("error");
            }
        }

    });

    return TabItemView;
});
